// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2o3o8","itemTitle":"ClientEmergencyInfo_itemTitle__gXAVm","itemText":"ClientEmergencyInfo_itemText__mSHHg"};